export default __webpack_public_path__ + "static/media/hogar.aed2dfda.png";